import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { CheckBorrower_Request } from '../models/CheckBorrower_Request.model';
import { GetDraft_Request } from '../models/GetDraft_Request';
import { SetBorrowers_Request } from '../models/SetBorrowers_Request.model';
import { UpdateDraftData } from '../models/UpdateDraftData';

@Injectable()
export class DraftHttpService {
  apiUri = environment.apiUri + "/TofesMashkanta";
  constructor(private httpClient: HttpClient) { }

  updateDraftData$(params: UpdateDraftData) {
    const url = `${this.apiUri}/updateDraftData`;
    return this.httpClient.post(url, params);
  }

  checkBorrower$(params: CheckBorrower_Request) {
    const url = `${this.apiUri}/checkBorrower`;
    return this.httpClient.post(url, params);
  }

  setBorrowers$(params: SetBorrowers_Request) {
    const url = `${this.apiUri}/setBorrowers`;
    return this.httpClient.post(url, params);
  }

  updateOpportunity$(params) {
    const url = `${this.apiUri}/updateOpportunity`;
    return this.httpClient.post(url,params);
  }

  sendTMFinal$(params) {
    const url = `${this.apiUri}/sendTMFinal`;
    return this.httpClient.post(url, params);
  }

  getDraft$(params:GetDraft_Request) {
    const url = `${this.apiUri}/getDraft`;  
    return this.httpClient.post(url, params);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/draft-http.service.ts